<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import CKEditor from "@ckeditor/ckeditor5-vue";
   import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

   export default {
      page: {
         title: "Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader , ckeditor: CKEditor.component},
      data() {
         return {
            title: "Settings",
            items: [
               {
                  text: "Settings",
                  active: true,
               },                   
            ],
            admin_image: "",
            admin_name: "admin",          
            username: "admin@medicino.com",
            password: "",
            password_confirmation: "",
            android_version: null,
            ios_version: null,
            facebook: "",
            twitter: "",
            instagram: "",          
            maintenance: 0,
            maintenance_reason: "",
            doctor_maintenance: 0,
            doctor_maintenance_reason: "",
            booking_charge: 10,
            token: "",
            errors: {},
             android_doctor_version: "",
            android_patient_version: "",
            ios_doctor_version: "",
            ios_patient_version: "",
            android_doctor_update: "",
            android_patient_update: "",
            ios_doctor_update: "",
            ios_patient_update: "",
            token_machine_note:"",
            points: "",
            points_rate: "",
            show_password: false,
            show_confirm_password: false,
            image_duration: "",
            tv_show_duration: "",
            old_pin: "",
            new_pin: "",
            cms: {

            title: "About Dhaamiye",
            editor: ClassicEditor,
            content: "<p>RSD is a mobile application platform for ordering fuel for your car from the convenience of your smartphone. We have set ourselves as an end-to-end technology platform and service provider emphasizing the software and hardware needs of mobile fueling companies, regardless of if they are direct to individual, commercial, fleet, and/or enterprise vehicles. By using the Dhaamiye app, your gas tank can be filled up while you go about your day.</p><p>We will come directly to your location and fuel up &nbsp;as many vehicles as your business needs.&nbsp;This will help save time and save money by&nbsp;eliminating the need to send employees to put&nbsp;&nbsp;fuel into your vehicles.</p><h2>Download the Apple App Store and Google Play Store.</h2><h1>Download Today</h1><ol><li>OPEN THE APP</li><li>BOOK YOUR FEUL DELIVERY</li><li>OPEN YOUR GAS FLAP</li></ol>",
            editorConfig: {
               
            }
            },
            settings: {
               // maintenance: 0,
               // maintenance_reason: "",
               // doctor_maintenance: 0,
               // doctor_maintenance_reason: "",
            },
            admin: {},

            image: '',
            preview_image: null,

            location: '',
            marker: { position: { lat: '', lng: '' } },
            center: { lat: '', lng: '' },
            current_place: '',

            mapOptions: {
               disableDefaultUI: true,
            },
            lab_content_A: "",
            lab_content_B: "",
            pharmacy_content_A: "",
            pharmacy_content_B: "",
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchSettings();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         //sets the position of marker when dragged
         handleMarkerDrag(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         panToMarker() {
            this.$refs.MapRef.panTo(this.marker.position);
            this.$refs.MapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         handleMapClick(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         setPlace(place) {
            this.current_place = place;
            if(this.current_place) {
               const marker = {
                  lat: this.current_place.geometry.location.lat(),
                  lng: this.current_place.geometry.location.lng(),
               };
               this.center = marker;
               this.marker.position = marker;
               this.location = place.formatted_address;
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         changePinNumber() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/change_pin";

            let formData = new FormData();
            formData.append("new_pin", this.new_pin); 
            formData.append("old_pin", this.old_pin); 
            formData.append("role_id", 1); 
            formData.append("id", 1); 
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         fetchSettings() {
            let url = "api/admin/settings/index";         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.settings = responseData.settings[0];
               this.admin = responseData.admins[0];

               this.marker.position.lat = this.settings.latitude;
               this.marker.position.lng = this.settings.longitude;

               this.center.lat = this.settings.latitude;
               this.center.lng = this.settings.longitude;
                        
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         updateProfile() {
            this.getToken();
            this.errors = {};
            let formData = new FormData();
            formData.append("name", this.admin.name);
            formData.append("email", this.admin.email);           
            formData.append("image", this.image);
            

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            this.loading = true;            
            
            this.$axios
               .post("api/admin/settings/admin/edit", formData, config)
               .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     var user = response.data.data[0];
                     console.log(user);
                     var medicino_admin = {};
                     if (localStorage.getItem('medicino_admin')) {
                        medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                     }

                     medicino_admin.email = user.email;
                     medicino_admin.image = user.image;
                     medicino_admin.username = user.username;
                     medicino_admin.name = user.name;

                     localStorage.setItem('medicino_admin', JSON.stringify(medicino_admin));
                     
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }

                  //this.clearForm();                  
                  this.$router.go().catch(()=>{});
               })
               .catch((error) => {

                  if (error.response) {
                     console.log(error.response);
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        //this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     //this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
               this.show_password = false;
            }
         },

         toggleCurrentPassword() {
            if(this.show_current_password == false) {
               this.show_current_password = true;
            } else {
               this.show_current_password = false;
            }
         },

         toggleConfirmPassword() {
            if(this.show_confirm_password == false) {
               this.show_confirm_password = true;
            } else {
               this.show_confirm_password = false;
            }
         },

         changePassword() {

            this.getToken();
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var data = JSON.stringify({
               "password": this.password,
               "password_confirmation": this.password_confirmation
            });
            
            this.loading = true;

            this.$axios
               .post("api/admin/settings/password/change", data, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {
            this.password = "";
            this.password_confirmation = "";

            this.old_pin = "";
            this.new_pin = "";

            this.image = "";
            this.preview_image = "";

            this.marker.position.lat = "";
            this.marker.position.lng = "";

            this.center.lat = "";
            this.center.lng = "";

            this.location = "";

            this.lab_content_A = "";
            this.lab_content_B = "";
            this.pharmacy_content_A = "";
            this.pharmacy_content_B = "";

            this.errors = {};
         },

         updateCharges() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/charges/edit";

            let formData = new FormData();
            formData.append("offline_service_charge", this.settings.offline_service_charge);
            formData.append("regular_delivery_charge", this.settings.regular_delivery_charge);           
            formData.append("express_delivery_charge", this.settings.express_delivery_charge);           
            formData.append("refund_rate", this.settings.refund_rate);           
            formData.append("tax_rate", this.settings.tax_rate);
            formData.append("print_token_range", this.settings.print_token_range);           

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateTax() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/updateTax";

            let formData = new FormData();
            formData.append("convenience_tax_rate", this.settings.convenience_tax_rate);
            formData.append("platform_tax_rate", this.settings.platform_tax_rate);
            formData.append("delivery_charge_tax_rate", this.settings.delivery_charge_tax_rate);
            if(this.settings.convenience_sac_code){
               formData.append("convenience_sac_code", this.settings.convenience_sac_code);
            }
            if(this.settings.convenience_sac_code){
               formData.append("platform_sac_code", this.settings.platform_sac_code);
            }
            if(this.settings.delivery_charge_sac_code){
               formData.append("delivery_charge_sac_code", this.settings.delivery_charge_sac_code);
            }
            formData.append("convenience_cess_rate", this.settings.convenience_cess_rate);
            formData.append("platform_cess_rate", this.settings.platform_cess_rate);
            formData.append("delivery_charge_cess_rate", this.settings.delivery_charge_cess_rate);

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateSocialMedia() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/socialmedia/edit";

            let formData = new FormData();
            formData.append("facebook", this.settings.facebook);
            formData.append("instagram", this.settings.instagram);           
            formData.append("twitter", this.settings.twitter);           
            
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateCallus() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/callus/edit";

            let formData = new FormData();
            formData.append("phone", this.settings.phone);
            formData.append("whatsapp", this.settings.whatsapp);           
            
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateCoordinates() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/coordinates/edit";

            let formData = new FormData();
            formData.append("latitude", this.marker.position.lat);
            formData.append("longitude", this.marker.position.lng);           
            
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         updateNote() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/token_note/edit";

            let formData = new FormData();
            formData.append("note",this.settings.token_machine_note);

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         updateCancellationNote() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/cancellation_note/edit";

            let formData = new FormData();
            formData.append("cancellation_note",this.settings.cancellation_note);

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updatePrintTokenNote() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/print_token_notes/edit";

            let formData = new FormData();
            formData.append("lab",this.settings.lab_print_token_note);
            formData.append("pharmacy",this.settings.pharmacy_print_token_note);
            formData.append("consultation",this.settings.consultation_print_token_note);
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         updatePoint() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/point/edit";

            let formData = new FormData();
            formData.append("point",this.settings.point);
            formData.append("point_rate",this.settings.point_rate);

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateMaintenance() {
            this.getToken();           
               const config = {
                  headers: {
                     "Content-type": "multipart/form-data",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };

            let url = "api/admin/settings/maintenance/edit";

            let formData = new FormData();
            formData.append("maintenance", this.settings.maintenance);
            if(this.settings.maintenance_reason){
               formData.append("maintenance_reason", this.settings.maintenance_reason);
            }else{
               formData.append("maintenance_reason", "");
            }
            formData.append("doctor_maintenance", this.settings.doctor_maintenance);
            // if(this.settings.maintenance_reason){
               formData.append("doctor_maintenance_reason", this.settings.doctor_maintenance_reason);
            // }else{
            //    formData.append("doctor_maintenance_reason", "");
            // }
            formData.append("patient_maintenance_android", this.settings.patient_maintenance_android);
            formData.append("patient_maintenance_reason_android", this.settings.patient_maintenance_reason_android);
            formData.append("doctor_maintenance_ios", this.settings.doctor_maintenance_ios);
            formData.append("doctor_maintenance_reason_ios", this.settings.doctor_maintenance_reason_ios);
            formData.append("clinic_maintenance", this.settings.clinic_maintenance);
            formData.append("lab_maintenance", this.settings.lab_maintenance);
            formData.append("clinic_maintenance_reason", this.settings.clinic_maintenance_reason);
            formData.append("lab_maintenance_reason", this.settings.lab_maintenance_reason);
            formData.append("token_maintenance", this.settings.token_maintenance);
            formData.append("tv_maintenance", this.settings.tv_maintenance);
            formData.append("token_maintenance_reason", this.settings.token_maintenance_reason);
            formData.append("tv_maintenance_reason", this.settings.tv_maintenance_reason);
            formData.append("urovo_maintenance", this.settings.urovo_maintenance);
            formData.append("urovo_maintenance_reason", this.settings.urovo_maintenance_reason);
            formData.append("falcon_maintenance", this.settings.falcon_maintenance);
            formData.append("falcon_maintenance_reason", this.settings.falcon_maintenance_reason);
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateVersion() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/versioncontrol/edit";

            let formData = new FormData();
            formData.append("android_doctor_version", this.settings.android_doctor_version);
            formData.append("android_patient_version", this.settings.android_patient_version);           
             formData.append("ios_doctor_version", this.settings.ios_doctor_version);
            formData.append("ios_patient_version", this.settings.ios_patient_version);
            formData.append("android_doctor_update", this.settings.android_doctor_update);
            formData.append("android_patient_update", this.settings.android_patient_update);           
            formData.append("ios_doctor_update", this.settings.ios_doctor_update);
            formData.append("ios_patient_update", this.settings.ios_patient_update);           
            formData.append("android_tv_version", this.settings.android_tv_version);           
            formData.append("android_tv_update", this.settings.android_tv_update);           
            formData.append("token_version", this.settings.token_version);
            formData.append("playstore_token_update", this.settings.playstore_token_update);
            formData.append("urovo_version", this.settings.urovo_version);
            formData.append("playstore_urovo_update", this.settings.playstore_urovo_update);
            formData.append("falcon_version", this.settings.falcon_version);
            formData.append("playstore_falcon_update", this.settings.playstore_falcon_update);

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateDuration() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/updateSlotDuration";

            let formData = new FormData();
            formData.append("tv_show_duration",this.settings.tv_show_duration);
            formData.append("image_duration",this.settings.image_duration);

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         updateContent() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/contentUpdate";

            let formData = new FormData();
            formData.append("lab_content_A", this.settings.lab_content_A);
            formData.append("lab_content_B", this.settings.lab_content_B);
            formData.append("pharmacy_content_A", this.settings.pharmacy_content_A);
            formData.append("pharmacy_content_B", this.settings.pharmacy_content_B);
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Admin Details</h4>
                  <b-form @submit.prevent="updateProfile()">
                     <b-row>
                        <b-col md="4" lg="5" class="form-group">
                           <label class="control-label">Name</label>
                           <b-form-input v-model="admin.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>

                           <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="5" lg="5" class="form-group">
                           <label class="control-label">Email</label>
                           <b-form-input v-model="admin.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                           <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" lg="2" class="form-group">
                        </b-col>
                        <b-col md="9" lg="10" class="form-group">
                           <label class="control-label">Admin image <span class="note">[Allowed Formats: jpg, jpeg, png.]</span></label><br>
                           <img v-if="admin.image" :src="$image_url + admin.image" class="avatar-sm mb-2" alt="" />
                           <input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
                           
                           <div class="note">Leave this field empty if you don't want to add/edit the image</div>

                           <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                           
                        </b-col>
                        <b-col md="3" lg="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="submit-button mb-3" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <!--  <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Password</h4>
                  <b-form @submit.prevent="changePassword()">
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-input-group>
                              <b-form-input type="password" v-model="password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-form-input type="text" v-model="password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                               
                               
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-input-group>
                                 <b-form-input type="password" v-model="password_confirmation" v-if="!show_confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                                 <b-form-input type="text" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }" v-else></b-form-input>
                                 <b-input-group-text @click="toggleConfirmPassword()">
                                    <i class="fas fa-eye" v-if="show_confirm_password"></i>
                                    <i class="fas fa-eye-slash" v-else></i>
                                 </b-input-group-text>

                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>                              
                           </b-input-group>
                        </b-col>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                        
                     </b-row>
                  </b-form>
               </div>
            </div> -->

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Pin Number</h4>
                  <b-form @submit.prevent="changePinNumber()">
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Old Pin Number<span class="text-danger">*</span></label>
                           <b-form-input v-model="old_pin" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.old_pin) }"></b-form-input>
                              <div v-for="(val, index) in errors.old_pin" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">New Pin Number<span class="text-danger">*</span></label>
                           <b-form-input v-model="new_pin" @keypress="numbersOnly" maxlength="4" autocomplete="off" v-bind:class="{ 'is-invalid': Boolean(errors.new_pin) }"></b-form-input>

                           <div v-for="(val, index) in errors.new_pin" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                        
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Charges</h4>
                  <b-form @submit.prevent="updateCharges()">
                     <b-row>
                        <!-- <b-col md="3" class="form-group">
                           <label class="control-label">Offline Service Charge <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="settings.offline_service_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.offline_service_charge) }"/>
                           <div v-for="(val, index) in errors.offline_service_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col> -->
                        <b-col md="3" class="form-group">
                           <label class="control-label">Refund Rate<br>(in %)</label>
                           <input type="text" class="form-control" v-model="settings.refund_rate"  v-bind:class="{ 'is-invalid': Boolean(errors.refund_rate) }"/>
                           <div v-for="(val, index) in errors.refund_rate" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Regular Delivery Charge per KM <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="settings.regular_delivery_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.regular_delivery_charge) }"/>
                           <div v-for="(val, index) in errors.regular_delivery_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Express Delivery Charge (Fixed) <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="settings.express_delivery_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.express_delivery_charge) }"/>
                           <div v-for="(val, index) in errors.express_delivery_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Print Token Range <br>(in Km)</label>
                           <input type="text" class="form-control" v-model="settings.print_token_range"  v-bind:class="{ 'is-invalid': Boolean(errors.print_token_range) }"/>
                           <div v-for="(val, index) in errors.print_token_range" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Tax Details</h4>
                  <b-form @submit.prevent="updateTax()">
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Convenience Fee Tax</label>
                            <select class="form-control" v-model="settings.convenience_tax_rate" v-bind:class="{ 'is-invalid': Boolean(errors.convenience_tax_rate) }">
                                 <option value="0">0%</option>
                                 <option value="5">5%</option>
                                 <option value="12">12%</option>
                                 <option value="18">18%</option>
                                 <option value="24">24%</option>
                           </select>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Convenience Fee SAC Code</label>
                           <input type="text" class="form-control" v-model="settings.convenience_sac_code"  v-bind:class="{ 'is-invalid': Boolean(errors.convenience_sac_code) }"/>
                           <div v-for="(val, index) in errors.convenience_sac_code" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col> 
                        <b-col md="3" class="form-group">
                           <label class="control-label">Convenience Fee Sess Rate</label>
                           <b-form-input type="number" step="any" v-model="settings.convenience_cess_rate" v-bind:class="{ 'is-invalid': Boolean(errors.convenience_cess_rate) }"></b-form-input>
                              <div v-for="(val, index) in errors.convenience_cess_rate" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                        </b-col>                      
                     </b-row>
                      <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Platform Fee Tax</label>
                            <select class="form-control" v-model="settings.platform_tax_rate" v-bind:class="{ 'is-invalid': Boolean(errors.platform_tax_rate) }">
                                 <option value="0">0%</option>
                                 <option value="5">5%</option>
                                 <option value="12">12%</option>
                                 <option value="18">18%</option>
                                 <option value="24">24%</option>
                           </select>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Platform Fee SAC Code</label>
                           <input type="text" class="form-control" v-model="settings.platform_sac_code"  v-bind:class="{ 'is-invalid': Boolean(errors.platform_sac_code) }"/>
                           <div v-for="(val, index) in errors.platform_sac_code" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col> 
                        <b-col md="3" class="form-group">
                           <label class="control-label">Platform Fee Sess Rate</label>
                           <b-form-input type="number" step="any" v-model="settings.platform_cess_rate" v-bind:class="{ 'is-invalid': Boolean(errors.platform_cess_rate) }"></b-form-input>
                              <div v-for="(val, index) in errors.platform_cess_rate" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                        </b-col>                      
                     </b-row>
                      <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Delivery charge Tax</label>
                            <select class="form-control" v-model="settings.delivery_charge_tax_rate" v-bind:class="{ 'is-invalid': Boolean(errors.delivery_charge_tax_rate) }">
                                 <option value="0">0%</option>
                                 <option value="5">5%</option>
                                 <option value="12">12%</option>
                                 <option value="18">18%</option>
                                 <option value="24">24%</option>
                           </select>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Delivery Charge Fee SAC Code</label>
                           <input type="text" class="form-control" v-model="settings.delivery_charge_sac_code"  v-bind:class="{ 'is-invalid': Boolean(errors.delivery_charge_sac_code) }"/>
                           <div v-for="(val, index) in errors.delivery_charge_sac_code" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col> 
                        <b-col md="3" class="form-group">
                           <label class="control-label">Delivery Charge Sess Rate</label>
                           <b-form-input type="number" step="any" v-model="settings.delivery_charge_cess_rate" v-bind:class="{ 'is-invalid': Boolean(errors.delivery_charge_cess_rate) }"></b-form-input>
                              <div v-for="(val, index) in errors.delivery_charge_cess_rate" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                        </b-col> 
                         <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>                     
                     </b-row>
                       
                     
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Slot Duration</h4>
                  <b-form @submit.prevent="updateDuration()">
                     <b-row>
                        <b-col md="4" class="form-group">
                           <label class="control-label">TV Show (in seconds)</label>
                           <input type="text" class="form-control" v-model="settings.tv_show_duration"  v-bind:class="{ 'is-invalid': Boolean(errors.tv_show_duration) }"/>
                           <div v-for="(val, index) in errors.tv_show_duration" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       
                        <b-col md="1" class="form-group d-flex align-items-center justify-content-center">
                        </b-col>
                        
                        <b-col md="4" class="form-group">
                           <label class="control-label">Image (in seconds)</label>
                           <input type="text" class="form-control" v-model="settings.image_duration"  v-bind:class="{ 'is-invalid': Boolean(errors.image_duration) }"/>
                           <div v-for="(val, index) in errors.image_duration" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>        
                        
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Points</h4>
                  <b-form @submit.prevent="updatePoint()">
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Points</label>
                           <input type="text" class="form-control" v-model="settings.point"  v-bind:class="{ 'is-invalid': Boolean(errors.points) }"/>
                           <div v-for="(val, index) in errors.points" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" lg="2" xl="1" class="form-group d-flex align-items-center justify-content-center">
                           <label class="control-label">=</label>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Rate (in Rs.)</label>
                           <input type="text" class="form-control" v-model="settings.point_rate"  v-bind:class="{ 'is-invalid': Boolean(errors.point_rate) }"/>
                           <div v-for="(val, index) in errors.point_rate" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>                        
                        
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Social Media Links</h4>
                  <b-form @submit.prevent="updateSocialMedia()">
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Facebook</label>
                           <b-form-input v-model="settings.facebook" v-bind:class="{ 'is-invalid': Boolean(errors.facebook) }"></b-form-input>
                           <div v-for="(val, index) in errors.facebook" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Youtube</label>
                           <b-form-input v-model="settings.twitter" v-bind:class="{ 'is-invalid': Boolean(errors.twitter) }"></b-form-input>
                           <div v-for="(val, index) in errors.twitter" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Instagram</label>
                           <b-form-input v-model="settings.instagram" v-bind:class="{ 'is-invalid': Boolean(errors.instagram) }"></b-form-input>
                           <div v-for="(val, index) in errors.instagram" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Call Us</h4>
                  <b-form @submit.prevent="updateCallus()">
                     <b-row>
                        <b-col md="4" class="form-group">
                           <label class="control-label">Mobile</label>
                           <b-input-group size="md" prepend="+91">
                              <b-form-input v-model="settings.phone" v-bind:class="{ 'is-invalid': Boolean(errors.phone) }" @keypress="numbersOnly" maxlength="10"></b-form-input>
                              <div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <label class="control-label">Whatsapp</label>
                           <b-input-group size="md" prepend="+91">
                              <b-form-input v-model="settings.whatsapp" v-bind:class="{ 'is-invalid': Boolean(errors.whatsapp) }" @keypress="numbersOnly" maxlength="10"></b-form-input>
                              <div v-for="(val, index) in errors.whatsapp" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Latitude & Longitude</h4>
                  <b-form @submit.prevent="updateCoordinates()">
                     <b-row>
                        <b-col md="8" class="mb-3">
                           <label class="control-label">Location</label>
                           <GmapAutocomplete @place_changed="setPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="location"/>
                              
                           <GmapMap v-if="location"
                              :center="center"
                              :zoom="18"
                              map-style-id="roadmap"
                              :options="mapOptions"
                              style="width: 100%; height: 30vmin"
                              ref="mapRef"
                              @click="handleMapClick">
                              <GmapMarker
                                 :position="marker.position"
                                 :clickable="true"
                                 :draggable="true"
                                 @drag="handleMarkerDrag"
                                 @click="panToMarker"
                              />
                           </GmapMap>                          
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="4" class="form-group">
                           <label class="control-label">Latitude</label>
                           <b-form-input type="number" step="any" v-model="marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                           <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <label class="control-label">Longitude</label>
                           <b-form-input type="number" step="any" v-model="marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                           <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>


            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Maintenance Mode</h4>
                  <b-form @submit.prevent="updateMaintenance()">
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Patient App(Android)</label>
                           <select v-model="settings.patient_maintenance_android" class="form-control" :class="{ 'is-invalid': Boolean(errors.patient_maintenance_android) }" @change="settings.patient_maintenance_reason_android=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.patient_maintenance_android" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Doctor App(Android)</label>
                           <select v-model="settings.doctor_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.doctor_maintenance) }" @change="settings.doctor_maintenance_reason=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.doctor_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Patient App(Android)</label>
                           <ckeditor v-model="settings.patient_maintenance_reason_android" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.patient_maintenance_reason_android) }"> </ckeditor>
                           <div v-for="(val, index) in errors.patient_maintenance_reason_android" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Doctor App(Android)</label>
                           <ckeditor v-model="settings.doctor_maintenance_reason" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.doctor_maintenance_reason) }"></ckeditor>
                           <div v-for="(val, index) in errors.doctor_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>

                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Patient App(IOS)</label>
                           <select v-model="settings.maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.maintenance) }" @change="settings.maintenance_reason=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Doctor App(IOS)</label>
                           <select v-model="settings.doctor_maintenance_ios" class="form-control" :class="{ 'is-invalid': Boolean(errors.doctor_maintenance_ios) }" @change="settings.doctor_maintenance_reason_ios=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.doctor_maintenance_ios" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Patient App(IOS)</label>
                           <ckeditor v-model="settings.maintenance_reason" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.maintenance_reason) }"> </ckeditor>
                           <div v-for="(val, index) in errors.maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Doctor App(IOS)</label>
                           <ckeditor v-model="settings.doctor_maintenance_reason_ios" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.doctor_maintenance_reason_ios) }"></ckeditor>
                           <div v-for="(val, index) in errors.doctor_maintenance_reason_ios" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - TV App</label>
                           <select v-model="settings.tv_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.tv_maintenance) }" @change="settings.tv_maintenance_reason=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.tv_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Token Vending Machine(Pinelabs)</label>
                           <select v-model="settings.token_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.token_maintenance) }" @change="settings.token_maintenance_reason=''">
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                           </select>
                           <div v-for="(val, index) in errors.token_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - TV App</label>
                           <ckeditor v-model="settings.tv_maintenance_reason" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.tv_maintenance_reason) }"> </ckeditor>
                           <div v-for="(val, index) in errors.tv_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Token Vending Machine(Pinelabs)</label>
                           <ckeditor v-model="settings.token_maintenance_reason" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.token_maintenance_reason) }"></ckeditor>
                           <div v-for="(val, index) in errors.token_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Token Vending Machine (Urovo)</label>
                           <select v-model="settings.urovo_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.urovo_maintenance) }" @change="settings.urovo_maintenance_reason=''">
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                           </select>
                           <div v-for="(val, index) in errors.urovo_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Token Vending Machine (Falcon)</label>
                           <select v-model="settings.falcon_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.falcon_maintenance) }" @change="settings.falcon_maintenance_reason=''">
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                           </select>
                           <div v-for="(val, index) in errors.falcon_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Token Vending Machine (Urovo)</label>
                           <ckeditor v-model="settings.urovo_maintenance_reason" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.urovo_maintenance_reason) }"></ckeditor>
                           <div v-for="(val, index) in errors.urovo_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Token Vending Machine (Falcon)</label>
                           <ckeditor v-model="settings.falcon_maintenance_reason" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.falcon_maintenance_reason) }"></ckeditor>
                           <div v-for="(val, index) in errors.falcon_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Clinic</label>
                           <select v-model="settings.clinic_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.clinic_maintenance) }" @change="settings.clinic_maintenance_reason=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.clinic_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="6" class="form-group">
                           <label class="control-label">Maintenance - Lab</label>
                           <select v-model="settings.lab_maintenance" class="form-control" :class="{ 'is-invalid': Boolean(errors.lab_maintenance) }" @change="settings.lab_maintenance_reason=''">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                           </select>
                           <div v-for="(val, index) in errors.lab_maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                  <b-row>
                     <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Clinic</label>
                           <b-form-input v-model="settings.clinic_maintenance_reason" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_maintenance_reason) }"></b-form-input>
                           <div v-for="(val, index) in errors.clinic_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance - Lab</label>
                           <b-form-input v-model="settings.lab_maintenance_reason" v-bind:class="{ 'is-invalid': Boolean(errors.lab_maintenance_reason) }"></b-form-input>
                           <div v-for="(val, index) in errors.lab_maintenance_reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                  </b-row>

                     <!-- Update button aligned to the right -->
                     <b-row>
                        <b-col md="12" class="d-flex justify-content-end">
                           <b-button type="submit" class="submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-6">Version Control</h4>
                  <b-form @submit.prevent="updateVersion()">
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Android Doctor Version</label>
                           <b-form-input v-model="settings.android_doctor_version" v-bind:class="{ 'is-invalid': Boolean(errors.android_doctor_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.android_doctor_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                          <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.android_doctor_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.android_doctor_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.android_doctor_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     
                        <b-col md="6" class="form-group">
                           <label class="control-label">Android Patient Version</label>
                           <b-form-input v-model="settings.android_patient_version" v-bind:class="{ 'is-invalid': Boolean(errors.android_patient_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.android_patient_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                         <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.android_patient_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.android_patient_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.android_patient_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                      <b-col md="6" class="form-group">
                           <label class="control-label">IOS Doctor Version</label>
                           <b-form-input v-model="settings.ios_doctor_version" v-bind:class="{ 'is-invalid': Boolean(errors.ios_doctor_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.ios_doctor_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                          <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.ios_doctor_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.ios_doctor_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.ios_doctor_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     
                        <b-col md="6" class="form-group">
                           <label class="control-label">IOS Patient Version</label>
                           <b-form-input v-model="settings.ios_patient_version" v-bind:class="{ 'is-invalid': Boolean(errors.ios_patient_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.ios_patient_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                         <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.ios_patient_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.ios_patient_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.ios_patient_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       <b-col md="6" class="form-group">
                           <label class="control-label">Android TV Version</label>
                           <b-form-input v-model="settings.android_tv_version" v-bind:class="{ 'is-invalid': Boolean(errors.android_tv_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.android_tv_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                          <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.android_tv_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.android_tv_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.android_tv_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="6" class="form-group">
                           <label class="control-label">Token Vending Machine Version(Pinelabs)</label>
                           <b-form-input v-model="settings.token_version" v-bind:class="{ 'is-invalid': Boolean(errors.token_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.token_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.playstore_token_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.playstore_token_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.playstore_token_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Token Vending Machine Version(Urovo) </label>
                           <b-form-input v-model="settings.urovo_version" v-bind:class="{ 'is-invalid': Boolean(errors.urovo_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.urovo_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.playstore_urovo_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.playstore_urovo_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.playstore_urovo_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Token Vending Machine Version(Falcon)</label>
                           <b-form-input v-model="settings.falcon_version" v-bind:class="{ 'is-invalid': Boolean(errors.falcon_version) }"></b-form-input>
                           <div v-for="(val, index) in errors.falcon_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.playstore_falcon_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.playstore_falcon_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.playstore_falcon_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     
                     <b-row>
                        <b-col md="12" class="d-flex justify-content-end">
                           <b-button type="submit" class="submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Token Vending Machine Note</h4>
                  <b-form @submit.prevent="updateNote()">
                     <b-row>
                        <b-col md="10" class="form-group">
                           <textarea rows="2" class="form-control" v-model="settings.token_machine_note" v-bind:class="{ 'is-invalid': Boolean(errors.note) }">                           
                           </textarea>
                           <div v-for="(val, index) in errors.note" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col  class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Cancellation Policy Note</h4>
                  <b-form @submit.prevent="updateCancellationNote()">
                     <b-row>
                        <b-col md="10" class="form-group">
                           <textarea rows="2" class="form-control" v-model="settings.cancellation_note" v-bind:class="{ 'is-invalid': Boolean(errors.cancellation_note) }">                           
                           </textarea>
                           <div v-for="(val, index) in errors.cancellation_note" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col  class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>  ------>

              <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Success Page Notes</h4>
                  <b-form @submit.prevent="updatePrintTokenNote()">
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Lab Booking<span class="text-danger">*</span></label>
                           <ckeditor v-model="settings.lab_print_token_note" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.lab) }"></ckeditor>
                           <div v-for="(val, index) in errors.lab" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Pharmacy Booking<span class="text-danger">*</span></label>
                           <ckeditor v-model="settings.pharmacy_print_token_note" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.pharmacy) }"></ckeditor>
                           <div v-for="(val, index) in errors.pharmacy" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row>
                      <b-col md="12" class="form-group">
                           <label class="control-label">Doctor Booking <span class="text-danger">*</span></label>
                           <ckeditor v-model="settings.consultation_print_token_note" :editor="cms.editor" :config="cms.editorConfig" :class="{ 'is-invalid': Boolean(errors.consultation) }"></ckeditor>
                           <div v-for="(val, index) in errors.consultation" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="12" class="d-flex justify-content-end">
                           <b-button type="submit" class="submit-button" variant="primary">Update Notes</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Content Update</h4>
                  <b-form @submit.prevent="updateContent()">
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Lab Content A<span class="text-danger">*</span></label>
                           <textarea rows="4" class="form-control" v-model="settings.lab_content_A" :class="{ 'is-invalid': Boolean(errors.lab_content_A) }"></textarea>
                           <div v-for="(val, index) in errors.lab_content_A" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Lab Content B<span class="text-danger">*</span></label>
                           <textarea rows="4" class="form-control" v-model="settings.lab_content_B" :class="{ 'is-invalid': Boolean(errors.lab_content_B) }"></textarea>
                           <div v-for="(val, index) in errors.lab_content_B" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Pharmacy Content A<span class="text-danger">*</span></label>
                           <textarea rows="4" class="form-control" v-model="settings.pharmacy_content_A" :class="{ 'is-invalid': Boolean(errors.pharmacy_content_A) }"></textarea>
                           <div v-for="(val, index) in errors.pharmacy_content_A" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Pharmacy Content B<span class="text-danger">*</span></label>
                           <textarea rows="4" class="form-control" v-model="settings.pharmacy_content_B" :class="{ 'is-invalid': Boolean(errors.pharmacy_content_B) }"></textarea>
                           <div v-for="(val, index) in errors.pharmacy_content_B" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="12" class="d-flex justify-content-end">
                           <b-button type="submit" class="submit-button" variant="primary">Update Content</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

         </div>
      </div>
   </Layout>
</template>
